import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { constantCase } from 'change-case';
import { clone, isEqual } from 'lodash';
import moment from 'moment-timezone';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var clientApplicationNameMap = {
    gorgoroth: 'mobile',
    mountdoom: 'browser',
    system: 'system',
    api: 'api'
};
var CreateMaintenanceLogsService = /** @class */ (function () {
    function CreateMaintenanceLogsService(translateService) {
        this.translateService = translateService;
    }
    CreateMaintenanceLogsService.prototype.listMaintenancesLogsMapped = function (maintenanceLogs) {
        var _this = this;
        var logsMapped = [];
        maintenanceLogs.forEach(function (currentMaintenanceLog, index) {
            var previousMaintenanceLog = maintenanceLogs[index - 1];
            var maintenanceLog = tslib_1.__assign({}, clone(currentMaintenanceLog), { icon: 'icon-plus-circle-outline', typeLog: 'maintenance', colorBackground: 'new--background', eventName: _this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.CREATED'), dateCreatedAt: moment(currentMaintenanceLog.createdAt).local().format('DD/MM/YYYY'), dateTimeCreatedAt: moment(currentMaintenanceLog.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), clientApplicationName: clientApplicationNameMap[currentMaintenanceLog.clientApplicationName] || currentMaintenanceLog.clientApplicationName, showMessage: false });
            var createdMaintenanceLog = _this.generateCreateLog(maintenanceLog, previousMaintenanceLog);
            if (createdMaintenanceLog) {
                logsMapped.push(createdMaintenanceLog);
            }
            if (createdMaintenanceLog) {
                return;
            }
            var scheduleSuggestionLog = _this.generateScheduleSuggestionLog(maintenanceLog, previousMaintenanceLog);
            if (scheduleSuggestionLog) {
                logsMapped.push(scheduleSuggestionLog);
            }
            var updatedSegmentLog = _this.generateUpdatedSegmentLog(maintenanceLog, previousMaintenanceLog);
            if (updatedSegmentLog) {
                logsMapped.push(updatedSegmentLog);
            }
            var updatedTypeLog = _this.generateUpdatedMaintenanceTypeLog(maintenanceLog, previousMaintenanceLog);
            if (updatedTypeLog) {
                logsMapped.push(updatedTypeLog);
            }
            var updatedMessageLog = _this.generateUpdatedMessageLog(maintenanceLog, previousMaintenanceLog);
            if (updatedMessageLog) {
                logsMapped.push(updatedMessageLog);
            }
            var assignedUserLog = _this.generateAssignedToUserLog(maintenanceLog, previousMaintenanceLog);
            if (assignedUserLog) {
                logsMapped.push(assignedUserLog);
            }
            var unassignedUserLog = _this.generateUnassignedUserLog(maintenanceLog, previousMaintenanceLog);
            if (unassignedUserLog) {
                logsMapped.push(unassignedUserLog);
            }
            var updatedAssigneeLog = _this.generateUpdateAssignedLog(maintenanceLog, previousMaintenanceLog);
            if (updatedAssigneeLog) {
                logsMapped.push(updatedAssigneeLog);
            }
            var companyAssignedLog = _this.generateAssigneeCompanyLog(maintenanceLog, previousMaintenanceLog);
            if (companyAssignedLog) {
                logsMapped.push(companyAssignedLog);
            }
            var reallocatedCompanyLog = _this.generateRelocatedLog(maintenanceLog, previousMaintenanceLog);
            if (reallocatedCompanyLog) {
                logsMapped.push(reallocatedCompanyLog);
            }
            var canceledMaintenanceLog = _this.generateCanceledLog(maintenanceLog, previousMaintenanceLog);
            if (canceledMaintenanceLog) {
                logsMapped.push(canceledMaintenanceLog);
            }
            var refusedMaintenanceLog = _this.generateRefusedLog(maintenanceLog, previousMaintenanceLog);
            if (refusedMaintenanceLog) {
                logsMapped.push(refusedMaintenanceLog);
            }
            var reopenMaintenanceLog = _this.generateReopenedLog(maintenanceLog, previousMaintenanceLog);
            if (reopenMaintenanceLog) {
                logsMapped.push(reopenMaintenanceLog);
            }
            var archivedMaintenanceLog = _this.generateArchivedLog(maintenanceLog, previousMaintenanceLog);
            if (archivedMaintenanceLog) {
                logsMapped.push(archivedMaintenanceLog);
            }
            var unarchivedMaintenanceLog = _this.generateUnarchivedLog(maintenanceLog, previousMaintenanceLog);
            if (unarchivedMaintenanceLog) {
                logsMapped.push(unarchivedMaintenanceLog);
            }
        });
        return logsMapped;
    };
    CreateMaintenanceLogsService.prototype.generateCreateLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog) {
            return null;
        }
        var createdLogBy = null;
        if (String(log.clientApplicationName) === 'system') {
            createdLogBy = 'recurrence';
        }
        if (log.updatedBy && log.updatedBy.type && log.updatedBy.type.includes('eyeofsauron')) {
            createdLogBy = 'eyeofsauron';
        }
        return tslib_1.__assign({}, clone(log), { createdLogBy: createdLogBy, showMessage: true, isCreatedLog: true });
    };
    CreateMaintenanceLogsService.prototype.generateCanceledLog = function (log, previousMaintenanceLog) {
        var isUpdatedByEyeofsaruon = log.updatedBy && log.updatedBy.type && log.updatedBy.type.includes('eyeofsauron');
        var isChangedFromRequestedToCanceled = previousMaintenanceLog.status === 'requested' && log.status === 'canceled';
        var isRefused = isUpdatedByEyeofsaruon && isChangedFromRequestedToCanceled;
        var isChangedToCanceled = previousMaintenanceLog && previousMaintenanceLog.status !== 'canceled' && log.status === 'canceled';
        if (isChangedToCanceled && !isRefused) {
            return tslib_1.__assign({}, clone(log), { icon: 'icon-close', colorBackground: 'canceled--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.CANCELED'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.REASON', {
                    reason: log.statusDescription || this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.NOT_COMPLETED')
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateRefusedLog = function (log, previousMaintenanceLog) {
        var isUpdatedByEyeofsaruon = log.updatedBy && log.updatedBy.type && log.updatedBy.type.includes('eyeofsauron');
        var isChangedFromRequestedToCanceled = previousMaintenanceLog.status === 'requested' && log.status === 'canceled';
        var isRefused = isUpdatedByEyeofsaruon && isChangedFromRequestedToCanceled;
        if (isRefused) {
            return tslib_1.__assign({}, clone(log), { icon: 'icon-close', colorBackground: 'refused--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.REFUSED'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.REASON', {
                    reason: log.statusDescription || this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.NOT_COMPLETED')
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateAssigneeCompanyLog = function (log, previousMaintenanceLog) {
        if (!previousMaintenanceLog.company && log.company) {
            return tslib_1.__assign({}, clone(log), { image: 'ic_location_marker_19px', colorBackground: 'assigned-to-company--background', createdAt: moment(log.createdAt).add(1, 'second').toISOString(), eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.ASSIGNED_TO_COMPANY'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.DESCRIPTION.WAS_ASSIGNED_COMPANY', {
                    company: log.company.name
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateUpdatedMessageLog = function (log, previousMaintenanceLog) {
        if (log.message !== previousMaintenanceLog.message) {
            return tslib_1.__assign({}, clone(log), { image: 'ic_chat_20px', colorBackground: 'description-updated--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.DESCRIPTION_UPDATED'), showMessage: true });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateUpdatedSegmentLog = function (log, previousMaintenanceLog) {
        if ((log.segment && log.segment.id) !== (previousMaintenanceLog && previousMaintenanceLog.segment && previousMaintenanceLog.segment.id)) {
            return tslib_1.__assign({}, clone(log), { image: 'new_icon_edit_action-20px', colorBackground: 'segment-updated--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.SEGMENT_UPDATED', { newSegmentName: log.segment.name }), showMessage: false });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateUpdatedMaintenanceTypeLog = function (log, previousMaintenanceLog) {
        if ((log && log.maintenanceType && log.maintenanceType.id) !== (previousMaintenanceLog && previousMaintenanceLog.maintenanceType && previousMaintenanceLog.maintenanceType.id)) {
            return tslib_1.__assign({}, clone(log), { image: 'new_icon_edit_action-20px', colorBackground: 'maintenance-type-updated--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.MAINTENANCE_TYPE_UPDATED', { newMaintenanceTypeName: log.maintenanceType.name }), showMessage: false });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateAssignedToUserLog = function (log, previousMaintenanceLog) {
        if (!previousMaintenanceLog.assignee && log.assignee) {
            return tslib_1.__assign({}, clone(log), { image: 'ic_user_18px', colorBackground: 'assigned-to-user--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.ASSIGNED'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.DESCRIPTION.ASSIGNED', {
                    name: log.assignee && log.assignee.name
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateUnassignedUserLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog.assignee && !log.assignee) {
            return tslib_1.__assign({}, clone(log), { image: 'ic_user_add_18px', colorBackground: 'assigned-to-user--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.CHANGE_ASSIGNEE'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.DESCRIPTION.UNASSIGNED', {
                    name: previousMaintenanceLog.assignee.name
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateUpdateAssignedLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog.assignee && log.assignee &&
            previousMaintenanceLog.assignee.id !== log.assignee.id) {
            return tslib_1.__assign({}, clone(log), { image: 'ic_user_add_18px', colorBackground: 'assigned-to-user--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.CHANGE_ASSIGNEE'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.DESCRIPTION.ASSIGNED_UPDATED', {
                    previousAssignee: previousMaintenanceLog.assignee.name,
                    currentAssignee: log.assignee.name
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateRelocatedLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog.company && log.company &&
            previousMaintenanceLog.company.id !== log.company.id) {
            return tslib_1.__assign({}, clone(log), { icon: 'icon-swap-vertical', colorBackground: 'relocated--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.RELOCATED'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.DESCRIPTION.RELOCATED', {
                    previousCompany: previousMaintenanceLog.company.name,
                    currentCompany: log.company.name
                }), eventNote: log.relocationReason && this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.NOTE.REASON', {
                    reason: log.relocationReason
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateReopenedLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog.status === 'canceled' && log.status === 'new' && log.statusDescription) {
            return tslib_1.__assign({}, clone(log), { icon: 'icon-replay', colorBackground: 'reopened--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.REOPENED'), eventDescription: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.REASON', {
                    reason: log.statusDescription
                }) });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateArchivedLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog && !previousMaintenanceLog.archived && log.archived) {
            return tslib_1.__assign({}, clone(log), { icon: 'icon-box-download', colorBackground: 'archive--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.ARCHIVED') });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateUnarchivedLog = function (log, previousMaintenanceLog) {
        if (previousMaintenanceLog && previousMaintenanceLog.archived && !log.archived) {
            return tslib_1.__assign({}, clone(log), { icon: 'icon-box-upload', colorBackground: 'unarchive--background', eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.UNARCHIVED') });
        }
        return null;
    };
    CreateMaintenanceLogsService.prototype.generateScheduleSuggestionLog = function (log, previousMaintenanceLog) {
        var _this = this;
        var isFistLogWithScheduleSuggestion = !previousMaintenanceLog && log.scheduleSuggestions && log.scheduleSuggestions.length > 0;
        var isScheduleSuggestionStatusChanged = previousMaintenanceLog && log.scheduleSuggestions && !isEqual(log.scheduleSuggestionsStatus, previousMaintenanceLog.scheduleSuggestionsStatus);
        var isScheduleSuggestionChanged = previousMaintenanceLog && log.scheduleSuggestions && !isEqual(log.scheduleSuggestions, previousMaintenanceLog.scheduleSuggestions);
        if (isFistLogWithScheduleSuggestion || isScheduleSuggestionStatusChanged || isScheduleSuggestionChanged) {
            var datesFormatted = log.scheduleSuggestions.map(function (suggestion) {
                var dateFormatted = moment(suggestion.date).format('DD/MM/YYYY');
                if (!suggestion.time) {
                    return dateFormatted;
                }
                var _a = tslib_1.__read(suggestion.time.split(':'), 2), hour = _a[0], minute = _a[1];
                return dateFormatted + " " + hour + ":" + minute;
            });
            var eventNoteLines = datesFormatted.map(function (dateFormatted, index) {
                return _this.translateService.instant('MAINTENANCES.TABS.LOGS.MAINTENANCE.SCHEDULE_SUGGESTION_NOTE', { number: index + 1, dateTime: dateFormatted });
            });
            var eventNote = eventNoteLines.join('<br>');
            var status_1 = log.scheduleSuggestionsStatus === 'corporateSuggested' && (log.scheduleSuggestions == null || log.scheduleSuggestions.length === 0) ? 'removed' : log.scheduleSuggestionsStatus;
            return tslib_1.__assign({}, clone(log), { isCreatedLog: isFistLogWithScheduleSuggestion, icon: 'icon-calendar-clock', colorBackground: 'schedule-suggestion--background', eventName: this.translateService.instant("MAINTENANCES.TABS.LOGS.MAINTENANCE.SCHEDULE_SUGGESTION", {
                    status: this.translateService.instant("MAINTENANCES.TABS.LOGS.MAINTENANCE.SCHEDULE_SUGGESTION_STATUS_" + constantCase(status_1))
                }), eventNote: eventNote });
        }
    };
    CreateMaintenanceLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreateMaintenanceLogsService_Factory() { return new CreateMaintenanceLogsService(i0.ɵɵinject(i1.TranslateService)); }, token: CreateMaintenanceLogsService, providedIn: "root" });
    return CreateMaintenanceLogsService;
}());
export { CreateMaintenanceLogsService };
